module.exports = __webpack_public_path__ + "img/id-01.c28fce7c.png";